<input class="search" [(ngModel)]="searchQuery" placeholder="Search for icons" />
<button (click)="searchIcons(searchQuery)" class="searchButton btn btn-primary" type="button">Find Icons</button>

<p *ngIf="searching">Fetching data...</p>

<div *ngFor="let icon of icons" class="icon-container">
  <img src="{{ icon.images.png['512'] }}" (click)="clickIcon(icon);">
</div>
